import React from 'react';
import PropTypes from 'prop-types';
import { navigateTo, withPrefix } from 'gatsby-link';
import { Dropdown } from 'semantic-ui-react';

const LanguageSelect = (props) => {
  const { languages, current, pathname, search } = props;

  const handleChange = (e, d) => {
    const newSlug = d.value;            
    // If English, the URL may have either 'en' or nothing as lang prefix.
    // Here we account for both possibilities.
    const newPath = pathname.includes(`/${current}/`)
      ? pathname.replace(`/${current}/`, `/${newSlug}/`)
      : pathname.replace(withPrefix('/'), `${withPrefix('/')}${newSlug}/`);
    navigateTo(newPath.replace('/en/', '/') + search);
  };

  // convert languages to object that react-dropdown needs:
  const options = languages.map(lang => ({ value: lang.slug, key: lang.slug, text: lang.title }));

  // grab the current object from languages:
  const currentObj = languages.find(lang => lang.slug === current);
  try {
    // convert current obj to object that react-dropdown needs:
    const defaultValue = { value: currentObj.slug, text: currentObj.title };

    return (
      <Dropdown
        className="language-select"
        value={defaultValue.value}
        fluid
        selection
        scrolling
        options={options}
        onChange={handleChange}
      />
    );
  } catch (error) {
    return null;
  }
};

LanguageSelect.propTypes = {
  pathname: PropTypes.string.isRequired,
  current: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })),
};

export default LanguageSelect;



// WEBPACK FOOTER //
// ./src/components/LanguageSelect/LanguageSelect.js